import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import GameRps from '../GameRps/GameRps';
import GameRpsPlay from '../GameRps/GameRpsPlay';
import GamePersonaGate from '../../layout/GamePersonaGate';
export default function GameSection() {
  return <div className="min-w-0"><Routes>
    <Route index element={<Navigate to="rps" replace />} />
    <Route path="rps" element={<GameRps />} />
    <Route path="rps/play" element={<GamePersonaGate><GameRpsPlay /></GamePersonaGate>} />
    <Route path="*" element={<Navigate to="rps" replace />} />
  </Routes></div>;
}
